import ListEdit from "../UI/ListEdit";
import {Link} from "react-router-dom";
import React, {Fragment, useState} from "react";
import Box from "../UI/Box";
import {useOrderItems} from "../../hooks/useOrderItems";
import {useOrder} from "../../hooks/useOrder";

const OrderItemsList = (props) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const {orderItems, pagination} = useOrderItems(props.orderId, page, pageSize);
    const {order} = useOrder(props.orderId);

    const orderItemsList = orderItems.map(
        (orderItem) => {
            return {
                text            : orderItem.text,
                unitCount       : orderItem.unitCount,
                unitNettoPrice  : orderItem.unitNettoPrice + ' eur',
                unitTaxPrice    : orderItem.unitTaxPrice + ' eur',
                unitBruttoPrice : orderItem.unitBruttoPrice + ' eur',
                nettoPrice      : orderItem.nettoPrice + ' eur',
                taxPrice        : orderItem.taxPrice + ' eur',
                bruttoPrice     : orderItem.bruttoPrice + ' eur',
                taxPercentage   : (orderItem.taxPercentage * 100) + '%'
            }
        }
    );

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const listHeaders = [
        'Item',
        'Quantity',
        'Unit Net Price',
        'Unit Tax',
        'Unit Gross Price',
        'Net Price',
        'Tax',
        'Gross Price',
        'Tax %'
    ];

    const columns = {
        functionParams : [],
        dataKeys       : [
            'text',
            'unitCount',
            'unitNettoPrice',
            'unitTaxPrice',
            'unitBruttoPrice',
            'nettoPrice',
            'taxPrice',
            'bruttoPrice',
            'taxPercentage'
        ]
    }

    return (
        <Fragment>
            <Link to={'/orders'}>Back</Link>
            <Box>
                {order && (
                    <h1 className="mb-4">Order: {order.number}</h1>
                )}
                <ListEdit
                    headers={listHeaders}
                    items={orderItemsList}
                    columns={columns}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                />
            </Box>
        </Fragment>
    );
};

export default OrderItemsList;
